export default "__VITE_ASSET__7hYzrYSR__"